(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-collection-grid';

  function initSwatches(section) {
    var groups = section.querySelectorAll('.oddit-section-collection-grid__card-swatches');

    groups.forEach(function (group) {
      var swatches = group.querySelectorAll('.oddit-section-collection-grid__swatch');
      if (!swatches.length) return;

      function goToSwatch(swatch, e) {
        // Swatches live inside the card <a>; stop the card link from firing,
        // then navigate to the swatch's own (sibling color) product.
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        var url = swatch.getAttribute('data-swatch-url');
        if (url) {
          window.location.href = url;
        }
      }

      swatches.forEach(function (swatch) {
        swatch.setAttribute('role', 'link');
        swatch.setAttribute('tabindex', '0');

        swatch.addEventListener('click', function (e) {
          goToSwatch(swatch, e);
        });
        swatch.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            goToSwatch(swatch, e);
          }
        });
      });
    });
  }

  // Hover-to-play for cards whose second media is a video (RC-58).
  //
  // The stylesheet already fades `__card-img--hover` in on card hover, so this
  // only has to drive playback. Gated to devices that actually hover, so touch
  // users never download the clip, and skipped entirely under reduced-motion.
  function initHoverVideos(section) {
    if (!window.matchMedia) return;
    if (!window.matchMedia('(hover: hover)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var videos = section.querySelectorAll('video[data-hover-video]');

    videos.forEach(function (video) {
      if (video.__odditHoverVideoBound) return;
      video.__odditHoverVideoBound = true;

      // Bind to the card link so the whole card is the trigger, matching the
      // CSS selector that reveals the video.
      var trigger = video.closest('.oddit-section-collection-grid__card-link') || video.parentElement;
      if (!trigger) return;

      function play() {
        // Muted is required for programmatic playback under autoplay policies;
        // the attribute alone isn't always honoured, so set the property too.
        video.muted = true;
        if (video.preload === 'none') video.preload = 'auto';
        var attempt = video.play();
        // Rejects harmlessly when the pointer leaves before the load resolves.
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(function () {});
        }
      }

      function stop() {
        video.pause();
        try {
          video.currentTime = 0;
        } catch (e) {
          // Seeking before metadata exists throws in some browsers; harmless.
        }
      }

      trigger.addEventListener('mouseenter', play);
      trigger.addEventListener('mouseleave', stop);
      // Keyboard parity: the card link is focusable, so play on focus too.
      trigger.addEventListener('focusin', play);
      trigger.addEventListener('focusout', stop);
    });
  }

  function initSection(section) {
    if (!section || section.__odditCollectionGridInit) return;
    section.__odditCollectionGridInit = true;
    initSwatches(section);
    initHoverVideos(section);
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll
      ? scope.querySelectorAll(SECTION_SELECTOR)
      : [];
    sections.forEach(initSection);
    if (scope.matches && scope.matches(SECTION_SELECTOR)) {
      initSection(scope);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
